import React from "react"
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import {bytesToSize, generateDownloadUrl} from "../../utility/navigationUtil";
import {metaDataProperty} from "../preview/previewMetaData";
import {usePreviewContext} from "../../context/PreviewContext";
import {getDataType} from "../../utility/componentUtil";
import {useLinkTracking} from "tracking/hooks/useLinkTracking";

interface Props {
    download: any[],
    propertyName?: string,
    downloadTitle?: string | null
    hideSize?: boolean
    isHovered?: boolean
    noLink?: boolean
    showDocumentTitle?: boolean
    target?: string
    tabIndex?: number
    metadataId?: string
}

function CCODownloadButton(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    const iconBoxStyle = {
        height: '40px',
        width: '40px',
        padding: '10px',
        borderRadius: '50%',
        transition: 'background-color 1s ease-out',
        backgroundColor: props.isHovered ? 'primary.dark' : "primary.main"
    }
    const titleStyle = {
        textDecoration: 'none!important',
        transition: 'color 1s ease-out',
        color: props.isHovered ? "primary.main" : 'text.primary'
    }
    const flexStyle = {display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}
    const target = props.target || '_blank';

    const first = props.download?.[0];
    const downloadHref = first
        ? generateDownloadUrl(first.id ?? '', props.downloadTitle ?? first.title ?? '')
        : undefined;
    const documentTitle = props.downloadTitle ?? first.title;

    const linkHandler = useLinkTracking({
                                            href: props.noLink ? null : (downloadHref ?? null),
                                            target: target as '_self' | '_blank',
                                            contentLabel: documentTitle,
                                        });

    if (!first) return null as any;

    return props.download[0] && <Button
        tabIndex={props.tabIndex}
        data-cypress={'downloadButtonComponent'}
        component={props.noLink ? 'div' : Link}
        href={props.noLink ? undefined : generateDownloadUrl(
            props.download[0]!.id ?? '',
            props.downloadTitle ?? props.download[0]!.title ?? ''
        )}
        target={target}
        onClick={linkHandler}
        sx={{
            "&.MuiButtonBase-root:hover": {
                bgcolor: "transparent"
            },
            height: '70px'
        }}>
        <Stack
            direction="row"
            sx={{
                alignItems: "center",
                gap: 2
            }}>
            <Box sx={iconBoxStyle}> <DownloadRoundedIcon data-cypress={'downloadRoundedIcon'}
                                                         fontSize={'small'}
                                                         htmlColor={'white'}></DownloadRoundedIcon>
            </Box>
            <Box sx={flexStyle}>
                <Typography
                    sx={titleStyle} {...metaDataProperty(isPreview,
                                                         props.propertyName,
                                                         props.metadataId)}>{props.showDocumentTitle ?
                    props.downloadTitle || 'Download' : 'Download'}</Typography>
                {props.download[0] && props.download[0].data?.contentType ?
                    <Typography variant={'subtitle2'} sx={{
                        color: '#000'
                    }}>
                        ({getDataType(props.download[0].data?.contentType)}{props.hideSize ? '' :
                        ' ' + bytesToSize(props.download[0]!.data?.size || 0).replace('.', ',')})
                    </Typography> : ''}
            </Box>

        </Stack>
    </Button>;
}

export default CCODownloadButton